export const getRouteFromLogin = {
  execute(role: string): string {
    if (role == "1") return "/users";
    if (role == "2" || role == "5") return "/sample-book";
    if (role == "4") return "/advances";
    if (role == "3") return "/login";
    if (role == "6") return "/events";
    return "";
  },
};
